import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    cookieConsent: {
      value: false
    },
    mailer: {
      value: false
    },
    events: [
      {
        id: 0,
        title: 'Wav M8\'s',
        date: '15/09/17',
        time: '10pm – 2am',
        location: 'Four Quarters, London',
        stockMessage: 'Tickets',
        available: false,
        price: '2',
        url: '',
        lineUp: ['Stay Positive', 'Klahrk b2b ???', 'Waller', 'Fork and Knife', 'Will Lux'],
        description: 'We\'re taking over Four Quarters on the 15th of September.',
        image: '',
        images: [
          {
            id: 1,
            url: require('@/assets/images/hat/01.png')
          }
        ]
      },
      {
        id: 1,
        title: 'ALTCOIN #1',
        date: '18/01/19',
        time: '10pm – 3am',
        location: 'Bunker, London',
        stockMessage: 'Tickets',
        available: false,
        price: '3',
        url: 'https://www.residentadvisor.net/events/1195684',
        lineUp: ['Klahrk B2B Tal-bot', 'Kuiasu', 'Otang', 'Waller', 'Glimji Hideout'],
        description: 'Our regular night is back and we’re going on tour with our first stop being where we started in SE London - join us at Bunker with WARE selectors all night',
        image: require('@/assets/images/events/180119.png'),
        images: [
          {
            id: 1,
            url: require('@/assets/images/events/180119/01.png')
          },
          {
            id: 2,
            url: require('@/assets/images/events/180119/02.png')
          }
        ]
      },
      {
        id: 2,
        title: 'ALTCOIN #2',
        date: '14/02/19',
        time: '10pm – 3am',
        location: 'The Mother\'s Ruin, Bristol',
        stockMessage: 'Tickets',
        available: false,
        price: '3',
        url: 'https://www.residentadvisor.net/events/1208810',
        lineUp: ['Lapsung B2B Glot', 'Ship Sket', 'Klahrk B2B Tal-Bot', 'Kuiasu, Citytronix', 'Metatarsals', 'Otang', 'Waller'],
        description: 'ALTCOIN is on the road (!!) Our regular night is on tour and we’re landing in Bristol - join us at The Mother’s Ruin where we’re bringing along our favourites from the West alongside regular WARE selectors',
        image: require('@/assets/images/events/140219.png'),
        images: [
          {
            id: 1,
            url: require('@/assets/images/events/140219/01.png')
          },
          {
            id: 2,
            url: require('@/assets/images/events/140219/02.png')
          },
          {
            id: 3,
            url: require('@/assets/images/events/140219/03.png')
          }
        ]
      },
      {
        id: 3,
        title: 'ALTCOIN #3',
        date: '28/03/19',
        time: '11pm – 3am',
        stockMessage: 'Tickets',
        location: 'Wharf Chambers, Leeds',
        available: false,
        price: '3',
        url: 'https://www.residentadvisor.net/events/1225507',
        lineUp: ['Spinee B2B Kuiasu', 'Stolen Velour B2B Jabes', 'Phrixus', 'Lapsung', 'Klahrk B2B Tal-bot', 'Otang B2B DJ 6’2', 'Glimji Hideout'],
        description: 'ALTCOIN comes to Leeds. Our regular night is on tour with Leeds being our third stop (!!) To celebrate our first night above the M25 we have curated a stacked line up with PC Music legend SPINEE alongside all of our favourites from the city of Leeds, including artists from our friends at Treehouse, alongside WARE regulars.',
        image: require('@/assets/images/events/280319.png'),
        images: [
          {
            id: 1,
            url: require('@/assets/images/events/280319/01.png')
          },
          {
            id: 2,
            url: require('@/assets/images/events/280319/02.png')
          },
          {
            id: 3,
            url: require('@/assets/images/events/280319/03.png')
          }
        ]
      },
      {
        id: 4,
        title: 'ALTCOIN #4',
        date: '19/04/19',
        time: '11pm – 5am',
        location: 'Rye Wax, London',
        stockMessage: 'Tickets',
        available: false,
        price: '5',
        url: 'https://www.residentadvisor.net/events/1233870',
        lineUp: ['Lil Data', 'Gribs', 'Slugabed + ????', 'Lapsung Presents: Moonbeams', 'Klahrk + Tal-bot', 'Cralias + DJ Animebby + Kuiasu', 'DJ Fingerblast', 'Citytronix', 'Space Candy', 'Glimji Hideout', 'DJ 6’2 + Otang'],
        description: 'The climax of ALTCOIN 2019 takes us to Rye Wax for our biggest show yet. A monumental gathering of forces from the worlds of PC Music, Planet Fun, Tobago Tracks and Moonbeams alongside all our regular Ware selectors.',
        image: require('@/assets/images/events/190419.png'),
        images: [
          {
            id: 1,
            url: require('@/assets/images/events/190419/01.png')
          },
          {
            id: 2,
            url: require('@/assets/images/events/190419/02.png')
          }
        ]
      },
      {
        id: 5,
        title: 'Visiting Party',
        date: '11/07/19',
        time: '10pm – 2:30am',
        location: 'Rye Wax, London',
        stockMessage: 'Tickets',
        available: false,
        price: '6',
        url: 'https://www.residentadvisor.net/events/1272121',
        lineUp: ['umru', 'Surati', 'Slugabed', 'Lil Data', 'Lila Tirando A Violeta + Nahshi', 'Kuiasu', 'Klahrk', 'Citytronix'],
        description: 'WARE returns to Rye Wax after our UK-wide Altcoin run of shows to present the PC Music, search engine optimised, young pop legend umru for their London debut, along with our friends at Activia Benz.',
        image: require('@/assets/images/events/110719.png'),
        images: [
          {
            id: 1,
            url: require('@/assets/images/events/110719/01.png')
          },
          {
            id: 2,
            url: require('@/assets/images/events/110719/02.png')
          }
        ]
      },
      {
        id: 6,
        title: 'Live. Laugh. Club.',
        date: '17/10/19',
        location: 'Rye Wax, London',
        time: '11pm – 2:30am',
        stockMessage: 'Tickets',
        available: true,
        price: '6',
        url: 'https://dice.fm/partner/ware-collective/event/oy9lr-hdmirror-17th-oct-rye-wax-london-tickets?fbclid=IwAR2koDFWY9Jhjjf9QYwbqEnwRfZjMnIFVQguk_EJL0e0mHRNRaoDCKyk29M&_branch_match_id=703288513827680852',
        lineUp: ['HDMIRROR (Live)', 'Helvetican', 'nurse3D', 'Baby Flame', 'Kuiasu b2b Waller', 'DJ Fingerblast', 'Klahrk', 'Otang b2b Glimji Hideout'],
        description: 'Avant Trance Master HDMIRROR joins us as we return to Rye Wax for a night of euphoria. He is joined by all our favourites alongside a UK debut for six impala affiliate Helvetican. Live, Laugh, Club.',
        image: require('@/assets/images/events/171019.png'),
        images: [
          {
            id: 1,
            url: require('@/assets/images/events/171019/01.png')
          }
        ]
      }
    ],
    shop: [
      {
        id: 0,
        title: 'A Future Cancelled',
        author: 'Klahrk',
        serial: 'ware001',
        stockMessage: 'Sold Out',
        available: false,
        price: '10',
        ppUrl: 'https://www.paypal.com/webapps/hermes?token=02Y358751S974334H&useraction=commit&rm=1&mfid=1545441778297_3a9ed638befaa',
        description: 'A hauntological series of abstract, experimental and at times violent, IDM tracks – Klahrk’s debut release ‘A Future Cancelled’ is an eerie mixture of sounds, beats and samples chronicling the emotional backdrop of the 21st Century (or gloomy lack thereof).',
        image: require('@/assets/images/afc.png'),
        images: [
          {
            id: 1,
            url: require('@/assets/images/afc/01.png')
          }
        ],
        trackList: [
          {
            id: 1,
            title: 'Two Modes',
            author: 'Klahrk',
            trackUrl: require('@/assets/sounds/afc/two-modes.mp3')
          },
          {
            id: 2,
            title: 'Death Drive',
            author: 'Klahrk',
            trackUrl: require('@/assets/sounds/afc/death-drive.mp3')
          },
          {
            id: 3,
            title: 'Reality Effect ft. Talbot',
            author: 'Klahrk',
            trackUrl: require('@/assets/sounds/afc/reality-effect.mp3')
          },
          {
            id: 4,
            title: '21st Century Sadness',
            author: 'Klahrk',
            trackUrl: require('@/assets/sounds/afc/21st-century-sadness.mp3')
          }
        ]
      },
      {
        id: 1,
        title: 'Ware 2018',
        author: 'Compilation',
        serial: 'ware002',
        stockMessage: 'Buy Now',
        available: true,
        price: '10',
        ppUrl: 'XGASH2REHFPLJ',
        description: 'A collection of work in celebration of the first year of WARE. Featuring original material from Arigto, Citytronix, Klahrk, Otang, Tal-bot and Waller. Alongside an extension of our first release ‘A Future Cancelled’ by Klahrk, including the Remixes, Stems and other materials.',
        image: require('@/assets/images/usb.png'),
        images: [
          {
            id: 1,
            url: require('@/assets/images/ware-2018/01.png')
          }
        ],
        trackList: [
          {
            id: 1,
            title: 'Phantasmagorical',
            author: 'Arigto',
            trackUrl: require('@/assets/sounds/ware-2018/arigto-phantasmagorical.mp3')
          },
          {
            id: 2,
            title: 'Dripped In Fear',
            author: 'Citytronix',
            trackUrl: require('@/assets/sounds/ware-2018/dripped-in-fear.mp3')
          },
          {
            id: 3,
            title: 'Fortify',
            author: 'Citytronix',
            trackUrl: require('@/assets/sounds/ware-2018/fortify.mp3')
          },
          {
            id: 4,
            title: 'Pear of Anguish',
            author: 'Citytronix',
            trackUrl: ''
          },
          {
            id: 5,
            title: 'Softest Bones',
            author: 'Citytronix',
            trackUrl: ''
          },
          {
            id: 6,
            title: 'Woman',
            author: 'Citytronix',
            trackUrl: ''
          },
          {
            id: 7,
            title: 'A.M.P.A.V',
            author: 'Klahrk',
            trackUrl: require('@/assets/sounds/ware-2018/ampav.mp3')
          },
          {
            id: 8,
            title: 'I_E_',
            author: 'Klahrk',
            trackUrl: require('@/assets/sounds/ware-2018/i-e.mp3')
          },
          {
            id: 9,
            title: 'Fruitfuck (Klahrk Remix)',
            author: 'Citytronix',
            trackUrl: require('@/assets/sounds/ware-2018/fruitfuck-klahrk-remix.mp3')
          },
          {
            id: 10,
            title: 'Death Drive (Otang Remix)',
            author: 'Klahrk',
            trackUrl: require('@/assets/sounds/ware-2018/death-drive-otang-remix.mp3')
          },
          {
            id: 11,
            title: 'Reality Effect (909WRAITH Remix)',
            author: 'Klahrk',
            trackUrl: ''
          },
          {
            id: 12,
            title: 'Reality Effect (Fragile Remix)',
            author: 'Klahrk',
            trackUrl: ''
          },
          {
            id: 13,
            title: 'Reality Effect (Space Candy Remix)',
            author: 'Klahrk',
            trackUrl: ''
          },
          {
            id: 14,
            title: 'Two Modes (Waller Remix)',
            author: 'Klahrk',
            trackUrl: ''
          },
          {
            id: 15,
            title: 'Acid Rain Dance',
            author: 'Otang',
            trackUrl: ''
          },
          {
            id: 16,
            title: 'Let Me Be Your Fantasy (Otang’s Quick N Easy Mix)',
            author: 'Baby D',
            trackUrl: ''
          },
          {
            id: 17,
            title: 'Blue on Blue',
            author: 'Otang',
            trackUrl: ''
          },
          {
            id: 18,
            title: 'Dark Energy',
            author: 'Otang',
            trackUrl: ''
          },
          {
            id: 19,
            title: 'Snakecharmer',
            author: 'Otang',
            trackUrl: ''
          },
          {
            id: 20,
            title: 'Valley Effect',
            author: 'Otang',
            trackUrl: ''
          },
          {
            id: 21,
            title: 'Canon',
            author: 'Tal-Bot',
            trackUrl: require('@/assets/sounds/ware-2018/canon.mp3')
          },
          {
            id: 22,
            title: 'Anomaly',
            author: 'Waller',
            trackUrl: require('@/assets/sounds/ware-2018/anomoly.mp3')
          },
          {
            id: 23,
            title: 'Elephant',
            author: 'Waller',
            trackUrl: require('@/assets/sounds/ware-2018/elephant.mp3')
          },
          {
            id: 24,
            title: 'Forecast',
            author: 'Waller',
            trackUrl: ''
          },
          {
            id: 25,
            title: 'no. 34335 - found in SE15',
            author: 'Waller',
            trackUrl: ''
          },
          {
            id: 26,
            title: 'Untitled',
            author: 'Waller',
            trackUrl: ''
          }
        ]
      },
      {
        id: 2,
        title: 'Ambient Works',
        author: 'Citytronix',
        serial: 'ware003',
        stockMessage: 'Buy Now',
        available: true,
        price: '10',
        ppUrl: 'TAJDKRJVUMNN6',
        description: 'After a prolific year of releases varying from the haunting ‘Dripped In Fear’ featured on WARE 2018, to their mesmerising interpretations of noughtie‘s pop records on the continuous mix ‘IO’, we bring them back to how their year started. Celebrating a year since it’s digital release, we present Citytronix’s ’Ambient Works (Anniversary Edition)’ on tape. A personal and harrowing project. Out January 1st 2019. Limited release.',
        image: require('@/assets/images/drew-tape.png'),
        images: [
          {
            id: 1,
            url: require('@/assets/images/ambient-works/01.png')
          }
        ],
        trackList: [
          {
            id: 1,
            title: 'I',
            author: 'Citytronix',
            trackUrl: require('@/assets/sounds/ambient-works/i-ambientworks.mp3')
          },
          {
            id: 2,
            title: 'II',
            author: 'Citytronix',
            trackUrl: require('@/assets/sounds/ambient-works/ii-ambientworks.mp3')
          },
          {
            id: 3,
            title: 'III',
            author: 'Citytronix',
            trackUrl: require('@/assets/sounds/ambient-works/iii-ambientworks.mp3')
          },
          {
            id: 4,
            title: 'IV',
            author: 'Citytronix',
            trackUrl: require('@/assets/sounds/ambient-works/iv-ambientworks.mp3')
          },
          {
            id: 5,
            title: 'V',
            author: 'Citytronix',
            trackUrl: require('@/assets/sounds/ambient-works/v-ambientworks.mp3')
          },
          {
            id: 6,
            title: 'VI',
            author: 'Citytronix',
            trackUrl: require('@/assets/sounds/ambient-works/vi-ambientworks.mp3')
          },
          {
            id: 7,
            title: 'VII',
            author: 'Citytronix',
            trackUrl: require('@/assets/sounds/ambient-works/vii-ambientworks.mp3')
          },
          {
            id: 8,
            title: 'VII (alternate)',
            author: 'Citytronix',
            trackUrl: require('@/assets/sounds/ambient-works/vii-alternate-ambientworks.mp3')
          },
          {
            id: 9,
            title: 'VIII',
            author: 'Citytronix',
            trackUrl: require('@/assets/sounds/ambient-works/viii-ambientworks.mp3')
          },
          {
            id: 10,
            title: 'IX',
            author: 'Citytronix',
            trackUrl: require('@/assets/sounds/ambient-works/ix-ambientworks.mp3')
          },
          {
            id: 11,
            title: 'X',
            author: 'Citytronix',
            trackUrl: require('@/assets/sounds/ambient-works/x-ambientworks.mp3')
          },
          {
            id: 12,
            title: 'Jack (Bonus)',
            author: 'Citytronix',
            trackUrl: ''
          },
          {
            id: 13,
            title: 'Softest Bones (Bonus)',
            author: 'Citytronix',
            trackUrl: ''
          },
          {
            id: 14,
            title: 'Incubator (Bonus)',
            author: 'Citytronix',
            trackUrl: ''
          },
          {
            id: 15,
            title: 'Absent & Dazed (Bonus)',
            author: 'Citytronix',
            trackUrl: ''
          }
        ]
      },
      {
        id: 3,
        title: 'Altcoin',
        author: 'Viscount',
        serial: 'ware004',
        stockMessage: 'Buy Now',
        available: true,
        price: '10',
        ppUrl: 'RSQTBL7S7359S',
        description: 'After a month-long tour across the UK, Ware is pleased to present an album by the Viscount Collective: ALTCOIN. Blending fiction, cryptoeconomies and artificial intelligence with jungle and ambient electronic soundscapes, Altcoin takes form as an exclusive release on Minidisc and an elusive, accompanying novella (forthcoming). Out April 19th, 2019. Limited Release.',
        image: require('@/assets/images/minidisc.png'),
        images: [
          {
            id: 1,
            url: require('@/assets/images/altcoin/01.png')
          },
          {
            id: 2,
            url: require('@/assets/images/altcoin/02.png')
          },
          {
            id: 3,
            url: require('@/assets/images/altcoin/03.png')
          }
        ],
        trackList: [
          {
            id: 1,
            title: 'ICO',
            author: 'Viscount',
            trackUrl: require('@/assets/sounds/altcoin/1-ico.mp3')
          },
          {
            id: 2,
            title: 'Schrodingers Sky',
            author: 'Viscount',
            trackUrl: require('@/assets/sounds/altcoin/2-schrodingers-sky.mp3')
          },
          {
            id: 3,
            title: 'Sustained Imagery',
            author: 'Viscount',
            trackUrl: require('@/assets/sounds/altcoin/3-sustained-imagery.mp3')
          },
          {
            id: 4,
            title: 'Debasement',
            author: 'Viscount',
            trackUrl: require('@/assets/sounds/altcoin/4-debasement.mp3')
          },
          {
            id: 5,
            title: 'Can’t Get Me',
            author: 'Viscount',
            trackUrl: require('@/assets/sounds/altcoin/5-cant-get-me.mp3')
          },
          {
            id: 6,
            title: 'Countercontrol',
            author: 'Viscount',
            trackUrl: require('@/assets/sounds/altcoin/6-countercontrol.mp3')
          },
          {
            id: 7,
            title: 'Appetite For Apathy',
            author: 'Viscount',
            trackUrl: require('@/assets/sounds/altcoin/7-appetite-for-apathy.mp3')
          },
          {
            id: 8,
            title: 'Exonumia',
            author: 'Viscount',
            trackUrl: require('@/assets/sounds/altcoin/8-exonumia.mp3')
          },
          {
            id: 9,
            title: 'Aching In Faith',
            author: 'Viscount',
            trackUrl: require('@/assets/sounds/altcoin/9-aching-in-faith.mp3')
          },
          {
            id: 10,
            title: 'Morning Smog',
            author: 'Viscount',
            trackUrl: require('@/assets/sounds/altcoin/10-morning-smog.mp3')
          },
          {
            id: 11,
            title: 'Reverse Engineering',
            author: 'Viscount',
            trackUrl: require('@/assets/sounds/altcoin/11-reverse-engineering.mp3')
          },
          {
            id: 12,
            title: 'The Hangover Talking',
            author: 'Viscount',
            trackUrl: require('@/assets/sounds/altcoin/12-the-hangover-talking.mp3')
          }
        ]
      },
      {
        id: 4,
        title: 'Altcoin: Hat',
        author: 'Viscount',
        serial: 'ware004b',
        stockMessage: 'Buy Now',
        available: true,
        price: '15',
        ppUrl: 'QAEBWVZGAUG3U',
        description: 'A small run of hats celebrating ALTCOIN 2019. 100% Cotton. One size fits most.',
        image: require('@/assets/images/hat.png'),
        images: [
          {
            id: 1,
            url: require('@/assets/images/hat/01.png')
          },
          {
            id: 2,
            url: require('@/assets/images/hat/02.png')
          },
          {
            id: 3,
            url: require('@/assets/images/hat/03.png')
          },
          {
            id: 4,
            url: require('@/assets/images/hat/04.png')
          }
        ]
      }
    ],
    player: {
      title: 'Sustained Imagery',
      trackUrl: require('@/assets/sounds/viscount-sustained-imagery.mp3'),
      author: 'Viscount'
    },
    projects: [
      {
        id: 0,
        title: 'Altcoin',
        description: 'The DJ returned his gaze for a moment before seamlessly switching track. It was pitch black down here save for the lurid glow of an occasional screen – there was no signal but thankfully the gig had wi-fi. Four walls, a lid and a router – no one ever stops to ask what the cat is thinking: “Did the guy in the weird coat make it?” K slumped up against a wall with the rest, drunkenly tonguing his teeth with an anesthetized instrument. 1, 2, 3, 4… He glanced at his phone but couldn’t make out the time. Night shift on or night shift off? The sky outside could have been either/or, blue or black, one or the other – but until you went outside to check it was probably safer to assume it was both.',
        image: require('@/assets/images/atm.png')
      },
      {
        id: 1,
        title: 'USB',
        description: 'A collection of work in celebration of the first year of WARE. Featuring original material from Arigto, Citytronix, Klahrk, Otang, Tal-bot and Waller. Alongside an extension of our first release ‘A Future Cancelled’ by Klahrk, including the Remixes, Stems and other materials.',
        image: require('@/assets/images/usb.png')
      },
      {
        id: 2,
        title: 'Ambient Works',
        description: 'After a prolific year of releases varying from the haunting ‘Dripped In Fear’ featured on WARE 2018, to their mesmerising interpretations of noughtie‘s pop records on the continuous mix ‘IO’, we bring them back to how their year started. Celebrating a year since it’s digital release, we present Citytronix’s ’Ambient Works (Anniversary Edition)’ on tape. A personal and harrowing project. Out January 1st 2019. Limited release.',
        image: require('@/assets/images/drew-tape.png')
      },
      {
        id: 3,
        title: 'Viscount: Altcoin',
        description: 'After a month-long tour across the UK, Ware is pleased to present an album by the Viscount Collective: ALTCOIN. Blending fiction, cryptoeconomies and artificial intelligence with jungle and ambient electronic soundscapes, Altcoin takes form as an exclusive release on Minidisc and an elusive, accompanying novella (forthcoming). Out April 19th, 2019. Limited Release.',
        image: require('@/assets/images/minidisc.png')
      }
    ],
    wavMates: {
      trackList: [
        {
          id: 1,
          title: '001',
          author: 'Klahrk',
          trackUrl: require('@/assets/sounds/wav/wavm8s-001-klahrk.mp3'),
          soundcloudUrl: 'https://soundcloud.com/warecollective/wavm8s-001-klahrk?in=warecollective/sets/wav-m8s',
          image: require('@/assets/images/wav/wavm8s-001-klahrk.jpg')
        },
        {
          id: 2,
          title: '002',
          author: 'Will Lux',
          trackUrl: require('@/assets/sounds/wav/wavm8s-002-will-lux.mp3'),
          soundcloudUrl: 'https://soundcloud.com/warecollective/wavm8s-002-will-lux?in=warecollective/sets/wav-m8s'
        },
        {
          id: 3,
          title: '003',
          author: 'Citytronix',
          trackUrl: require('@/assets/sounds/wav/wavm8s-003-citytronix.mp3'),
          soundcloudUrl: 'https://soundcloud.com/warecollective/wavm8s003-citytronix?in=warecollective/sets/wav-m8s'
        },
        {
          id: 4,
          title: '004',
          author: 'Waller',
          trackUrl: require('@/assets/sounds/wav/wavm8s-004-waller.mp3'),
          soundcloudUrl: 'https://soundcloud.com/warecollective/wavm8s-004-waller?in=warecollective/sets/wav-m8s'
        },
        {
          id: 5,
          title: '005',
          author: 'DJ Mare',
          trackUrl: require('@/assets/sounds/wav/wavm8s-005-dj-mare.mp3'),
          soundcloudUrl: 'https://soundcloud.com/warecollective/wavm8s-005-dj-mare?in=warecollective/sets/wav-m8s'
        },
        {
          id: 6,
          title: '006',
          author: 'Polyop',
          trackUrl: require('@/assets/sounds/wav/wavm8s-006-polyop.mp3'),
          soundcloudUrl: 'https://soundcloud.com/warecollective/wavm8s-006-polyop?in=warecollective/sets/wav-m8s'
        },
        {
          id: 7,
          title: 'End Of Year Edition (2017)',
          author: 'Mixed by Klahrk',
          trackUrl: require('@/assets/sounds/wav/wavm8s-2017-end-of-year-edition.mp3'),
          soundcloudUrl: 'https://soundcloud.com/warecollective/wavm8s-end-of-year-edition?in=warecollective/sets/wav-m8s'
        },
        {
          id: 8,
          title: '007',
          author: 'Otang',
          trackUrl: require('@/assets/sounds/wav/wavm8s-007-otang.mp3'),
          soundcloudUrl: 'https://soundcloud.com/warecollective/wavm8s-007-otang?in=warecollective/sets/wav-m8s'
        },
        {
          id: 9,
          title: '008',
          author: 'Tal-Bot',
          trackUrl: require('@/assets/sounds/wav/wavm8s-008-tal-bot.mp3'),
          soundcloudUrl: 'https://soundcloud.com/warecollective/wavm8s-008-talbot?in=warecollective/sets/wav-m8s'
        },
        {
          id: 10,
          title: '009',
          author: 'Waller Subby & Dubby Mix',
          trackUrl: require('@/assets/sounds/wav/wavm8s-009-waller-subby-n-dubby-mix.mp3'),
          soundcloudUrl: 'https://soundcloud.com/warecollective/wavm8s-009-wallers-subby-dubby-mix?in=warecollective/sets/wav-m8s'
        },
        {
          id: 11,
          title: '010',
          author: 'Kattie',
          trackUrl: require('@/assets/sounds/wav/wavm8s-010-kattie.mp3'),
          soundcloudUrl: 'https://soundcloud.com/warecollective/wavm8s-010-kattie?in=warecollective/sets/wav-m8s'
        },
        {
          id: 12,
          title: '011',
          author: 'Roxas',
          trackUrl: require('@/assets/sounds/wav/wavm8s-011-roxas.mp3'),
          soundcloudUrl: 'https://soundcloud.com/warecollective/wavm8s-011-roxas?in=warecollective/sets/wav-m8s'
        },
        {
          id: 13,
          title: '012',
          author: 'Cralias',
          trackUrl: require('@/assets/sounds/wav/wavm8s-012-cralias.mp3'),
          soundcloudUrl: 'https://soundcloud.com/warecollective/wavm8s-012-cralias?in=warecollective/sets/wav-m8s',
          image: require('@/assets/images/wav/wavm8s-012-cralias.png')
        },
        {
          id: 14,
          title: '013',
          author: 'Arigto',
          trackUrl: require('@/assets/sounds/wav/wavm8s-013-arigto.mp3'),
          soundcloudUrl: 'https://soundcloud.com/warecollective/wavm8s-013-arigto?in=warecollective/sets/wav-m8s',
          image: require('@/assets/images/wav/wavm8s-013-arigto.png')
        },
        {
          id: 15,
          title: '014',
          author: 'Valiska',
          trackUrl: require('@/assets/sounds/wav/wavm8s-014-valiska.mp3'),
          soundcloudUrl: 'https://soundcloud.com/warecollective/wavm8s-014-valiska?in=warecollective/sets/wav-m8s',
          image: require('@/assets/images/wav/wavm8s-014-valiska.png')
        },
        {
          id: 16,
          title: '015',
          author: 'DJ Animebby',
          trackUrl: require('@/assets/sounds/wav/wavm8s-015-dj-animebby.mp3'),
          soundcloudUrl: 'https://soundcloud.com/warecollective/wavm8s-015-dj-animebby?in=warecollective/sets/wav-m8s',
          image: require('@/assets/images/wav/wavm8s-015-dj-animebby.png')
        },
        {
          id: 17,
          title: '016',
          author: 'Klahrk',
          trackUrl: require('@/assets/sounds/wav/wavm8s-016-klahrk.mp3'),
          soundcloudUrl: 'https://soundcloud.com/klahrk/wavm8s-016-klahrk?in=warecollective/sets/wav-m8s',
          image: require('@/assets/images/wav/wavm8s-016-klahrk.png')
        },
        {
          id: 18,
          title: '017',
          author: 'Otang',
          trackUrl: require('@/assets/sounds/wav/wavm8s-017-otang.mp3'),
          soundcloudUrl: 'https://soundcloud.com/warecollective/wavm8s-017-otang?in=warecollective/sets/wav-m8s',
          image: require('@/assets/images/wav/wavm8s-017-otang.png')
        },
        {
          id: 19,
          title: '018',
          author: 'Ware 2018 Edition',
          trackUrl: require('@/assets/sounds/wav/wavm8s-018-ware-2018-edition.mp3'),
          soundcloudUrl: 'https://soundcloud.com/warecollective/wavm8s-ware-2018-edition?in=warecollective/sets/wav-m8s',
          image: require('@/assets/images/wav/wavm8s-018-ware-2018-edition.png')
        },
        {
          id: 20,
          title: '019',
          author: 'Yajo',
          trackUrl: require('@/assets/sounds/wav/wavm8s-019-yajo.mp3'),
          soundcloudUrl: 'https://soundcloud.com/warecollective/wavm8s-019-yajo?in=warecollective/sets/wav-m8s',
          image: require('@/assets/images/wav/wavm8s-019-yajo.png')
        },
        {
          id: 21,
          title: '020',
          author: 'Glimji Hideout',
          trackUrl: require('@/assets/sounds/wav/wavm8s-020-glimji-hideout.mp3'),
          soundcloudUrl: 'https://soundcloud.com/warecollective/wavm8s-020-glimji-hideout?in=warecollective/sets/wav-m8s',
          image: require('@/assets/images/wav/wavm8s-020-glimji-hideout.png')
        },
        {
          id: 22,
          title: '021',
          author: 'Risik',
          trackUrl: require('@/assets/sounds/wav/wavm8s-021-risik.mp3'),
          soundcloudUrl: 'https://soundcloud.com/warecollective/wavm8s-021-risik?in=warecollective/sets/wav-m8s',
          image: require('@/assets/images/wav/wavm8s-021-risik.png')
        },
        {
          id: 23,
          title: '022',
          author: 'DJ Mare',
          trackUrl: require('@/assets/sounds/wav/wavm8s-022-dj-mare.mp3'),
          soundcloudUrl: 'https://soundcloud.com/warecollective/wavm8s-022-dj-mare?in=warecollective/sets/wav-m8s',
          image: require('@/assets/images/wav/wavm8s-022-dj-mare.png')
        },
        {
          id: 24,
          title: 'End of Year Edition (2018)',
          author: 'Mixed by Citytronix',
          trackUrl: require('@/assets/sounds/wav/wavm8s-2018-end-of-year-edition.mp3'),
          soundcloudUrl: 'https://soundcloud.com/warecollective/wavm8s-2018-end-of-year-edition-mixed-by-citytronix',
          image: require('@/assets/images/wav/wavm8s-2018-end-of-year-edition.png')
        },
        {
          id: 25,
          title: '023',
          author: 'Klahrk & Talbot',
          trackUrl: require('@/assets/sounds/wav/wavm8s-023-klahrk-talbot.mp3'),
          soundcloudUrl: 'https://soundcloud.com/warecollective/wavm8s-023-klahrk-tal-bot',
          image: require('@/assets/images/wav/wavm8s-023-klahrk-talbot.png')
        },
        {
          id: 26,
          title: '024',
          author: 'Fragile',
          trackUrl: require('@/assets/sounds/wav/wavm8s-024-fragile.mp3'),
          soundcloudUrl: 'https://soundcloud.com/warecollective/wavm8s-024-fragile',
          image: require('@/assets/images/wav/wavm8s-023-klahrk-talbot.png')
        },
        {
          id: 27,
          title: '025',
          author: 'Ship Sket',
          trackUrl: require('@/assets/sounds/wav/wavm8s-025-ship-sket.mp3'),
          soundcloudUrl: 'https://soundcloud.com/warecollective/wavm8s-025-ship-sket',
          image: require('@/assets/images/wav/wavm8s-023-klahrk-talbot.png')
        },
        {
          id: 28,
          title: '026',
          author: 'Phrixus',
          trackUrl: require('@/assets/sounds/wav/wavm8s-026-phrixus.mp3'),
          soundcloudUrl: 'https://soundcloud.com/warecollective/wavm8s-026-phrixus',
          image: require('@/assets/images/wav/wavm8s-023-klahrk-talbot.png')
        },
        {
          id: 29,
          title: '027',
          author: 'Kuiasu',
          trackUrl: require('@/assets/sounds/wav/wavm8s-027-kuiasu.mp3'),
          soundcloudUrl: 'https://soundcloud.com/warecollective/wavm8s-027-kuiasu',
          image: require('@/assets/images/wav/wavm8s-023-klahrk-talbot.png')
        },
        {
          id: 30,
          title: '028',
          author: 'Space Candy',
          trackUrl: require('@/assets/sounds/wav/wavm8s-028-space-candy.mp3'),
          soundcloudUrl: 'https://soundcloud.com/warecollective/wavm8s-028-space-candy',
          image: require('@/assets/images/wav/wavm8s-023-klahrk-talbot.png')
        }
      ]
    }
  },
  getters: {
    getCookies: state => state.cookieConsent.value,
    getEvents: state => state.events,
    getShopItems: state => state.shop,
    getPlayer: state => state.player,
    getProjects: state => state.projects,
    getMailer: state => state.mailer.value,
    getWavs: state => state.wavMates,
    getShopItembySerial: state => payload => state.shop.find(item => item.serial === payload),
    getEventbyID: state => payload => state.events[payload]
  },
  mutations: {
    cookieConsent (state) {
      state.cookieConsent.value = true
      console.log('🍪')
    },
    mailer (state) {
      state.mailer.value = true
      console.log('📬')
    },
    updatePlayer (state, payload) {
      let i = this.getters.getPlayer
      i.title = payload[0]
      i.trackUrl = payload[1]
      i.author = payload[2]
      console.log('The new track is ' + i.title + ', by ' + i.author + ', at ' + i.trackUrl)
    }
  },
  actions: {
    cookieConsent ({ commit }) {
      commit('cookieConsent')
    },
    mailer ({ commit }) {
      commit('mailer')
    },
    updatePlayer ({ commit }, payload) {
      commit('updatePlayer', payload)
    }
  }
})



// WEBPACK FOOTER //
// ./src/store/store.js